import { render, staticRenderFns } from "./PrizeRule.vue?vue&type=template&id=6026a07e&scoped=true"
import script from "./PrizeRule.vue?vue&type=script&lang=js"
export * from "./PrizeRule.vue?vue&type=script&lang=js"
import style0 from "./PrizeRule.vue?vue&type=style&index=0&id=6026a07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6026a07e",
  null
  
)

export default component.exports